<template>
	<div class="tempD" :style="{minHeight:tempH}" style="display: flex;flex-direction: row;">
		<!--<concactus></concactus>-->
		<div class="inDiv">

			<div class="infoTit">{{dataInfo.title}}</div>
			<div class="fabuLaiyuan">
				<span style="margin-right: 20px;">发布时间：{{dataInfo.create_time}}</span>
				<span>来自：{{dataInfo.author}}</span>
			</div>
			<div class="infoConutd" v-html="dataInfo.detail">

			</div>
		</div>
	</div>
</template>

<script>
	const concactus = () =>
		import("@/components/home/common/contactUs.vue"); //作品详情
	export default {
		components: {
			concactus
		},
		data() {
			return {
				content_id: 0,
				dataInfo: {},
				tempH: 0,
			}
		},
		created: function() {
			let _this = this;
			_this.content_id = _this.$route.query.content_id;
			_this.getInfo_api(_this.content_id);
			let offsetHeight = document.documentElement.clientHeight - 250 + 'px';
			_this.tempH = offsetHeight;
		},
		methods: {
			/*获取详情
			 创建于2019-11-25  作者：郑凯*/
			getInfo_api(id) {
				let _this = this;
				let paramsObj = {
					"content_id": id
				};
				_this.$axios({
					method: 'get',
					url: '/api/getContentInfo',
					headers: {},
					params: paramsObj
				}).then((response) => {
					let resObj = response.data;
					//console.log(JSON.stringify(resObj)) //请求成功返回的数据
					if(resObj.status == '00') {
						_this.dataInfo = resObj.data;
					} else if(resObj.status == 1001) {

					}
				}).catch((error) => {
					return false;
				});
			},
		}
	}
</script>

<style scoped>
	.tempD{ width: 90%; margin: auto; margin-top: 30px;}
	.infoTit{ text-align: center; font-weight: bold; font-size: 28px; margin-top: 40px;}
	.fabuLaiyuan{ text-align: right; padding: 20px 0 80px 0;}

</style>